import {MutationTree} from "vuex";
import {ReportsState} from "@/store/settings/reports/types";

export const mutations: MutationTree<ReportsState> = {
  setReports:((state, payload) => state.reports = payload)
}